import { Flex } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { SearchInput } from "components/ui/SearchInput/SearchInput";
import GroupButton, { ActionButton } from "components/ui/GroupButton/GroupButton";
import CustomText from "components/ui/CustomText/CustomText";
import { CommonParamsType } from "constants/types/common";
import { FORM_IDS } from "pages/Warehouse/config";
import { FC, useRef } from "react";
import { useSWRConfig } from "swr";
import { useAppModal } from "utils/hooks/ui/useAppModal";
import { getWarehouseListKey } from "utils/hooks/request/useWarehouses";
import CreateForm from "../CreateForm/CreateForm";

interface WarehouseActionsProps {
  handleSearch: (value: string) => void;
  params: CommonParamsType;
}

const WarehouseActions: FC<WarehouseActionsProps> = ({ handleSearch, params }) => {
  const { openCrudModal, closeCrudModal } = useAppModal();
  const activeModalId = useRef<string | null>(null);
  const { mutate } = useSWRConfig();

  const handleCloseModal = () => {
    if (activeModalId.current) {
      closeCrudModal(activeModalId.current);
      activeModalId.current = null;
    }
  };

  const handleOpenCreateModal = () => {
    const modalId = openCrudModal(
      <CustomText variant="section-title">Tạo mới nhà kho</CustomText>,
      {
        mode: "create",
        formId: FORM_IDS.CREATE,
        children: (
          <CreateForm
            mutate={() => mutate(getWarehouseListKey(params))}
            onClose={handleCloseModal}
          />
        ),
        submitText: "Tạo mới",
      },
      750,
    );
    activeModalId.current = modalId;
  };

  const actions: ActionButton[] = [
    {
      key: "create",
      label: "Tạo mới",
      icon: <IconPlus size={18} />,
      variant: "filled",
      color: "blue",
      isLoading: false,
      onClick: handleOpenCreateModal,
      permission: "warehouse:create",
    },
  ];

  return (
    <Flex justify="space-between" align="center">
      <SearchInput
        value={params.search || ""}
        onChange={handleSearch}
        placeholder="Tìm kiếm nhà kho"
      />
      <GroupButton actions={actions} />
    </Flex>
  );
};

export default WarehouseActions;
